import { css, etiColors } from '@eti/styles';
import { Icon } from '@eti/components';
import { jsx as _jsx } from "react/jsx-runtime";
const styles = (visited, hide) => css`
  align-items: center;
  background-color: ${visited ? etiColors.confirmation.solid : null};
  border: 0.125rem solid ${etiColors.white};
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 50%;
  opacity: ${hide ? 0 : 1};
  position: absolute;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition:
    opacity 0.5s,
    background-color 0.5s;
  width: 100%;

  & > svg {
    display: block;
    height: 0.5rem;
    transition: all 0.5s;
    width: 0.5rem;
  }
`;
const CheckMark = _ref => {
  let {
    shouldHide,
    isVisited
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    className: styles(isVisited, shouldHide),
    "data-testid": "seatMap-stepIndicatorItem-CheckMark",
    children: /*#__PURE__*/_jsx(Icon, {
      color: etiColors.white,
      id: "check"
    })
  });
};
export default CheckMark;
//# sourceMappingURL=CheckMark.js.map